import React, { Component } from 'react';
import { Divider, Switch, Button, Slider } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Alchemy extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      OldAlchemy: false,
      MaxOptLevel: 21,
      AdvancedElixir: true,
      ReqImmortalAfterPlus5: false,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Alchemy
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>Old Alchemy</td>
              <td>
                <Switch
                  checked={this.state.OldAlchemy}
                  {...SwitchOnOff}
                  onChange={this.handleChange('OldAlchemy')}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Item Plus</td>
              <td style={{ width: '360px' }}>
                <Slider
                  min={0}
                  max={255}
                  labelStepSize={30}
                  onChange={this.handleChange('MaxOptLevel')}
                  value={this.state.MaxOptLevel}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>Advanced Elixir</td>
              <td>
                <Switch
                  checked={this.state.AdvancedElixir}
                  {...SwitchOnOff}
                  onChange={this.handleChange('AdvancedElixir')}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>Require Immortal After (+5)</td>
              <td>
                <Switch
                  checked={this.state.ReqImmortalAfterPlus5}
                  {...SwitchOnOff}
                  onChange={this.handleChange('ReqImmortalAfterPlus5')}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
